import { render, staticRenderFns } from "./fabu.vue?vue&type=template&id=d641b9be&"
import script from "./fabu.vue?vue&type=script&lang=js&"
export * from "./fabu.vue?vue&type=script&lang=js&"
import style0 from "./fabu.vue?vue&type=style&index=0&id=d641b9be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports